import { toggleBlock } from "../helpers/toggleBlock";

const blocksPage = document.querySelectorAll('[data-blocks="accordion"]');

if (blocksPage) {
  accordion(blocksPage);
}

function accordion(blocksPage) {
  blocksPage.forEach((blocks) => {
    window.addEventListener("load", () => initOpen(blocks));

    blocks.addEventListener("click", (e) => {
      const block = e.target.closest('[data-block="accordion"]');
      const btnAccordion = e.target.closest('[data-btn="accordion"]');

      if (btnAccordion) {
        const openedBlock = blocks.querySelector(".open");
        toggleBlock(block);

        if (openedBlock && openedBlock !== block) {
          toggleBlock(openedBlock);
        }
      }
    });
  });
}

function initOpen(blocks) {
  const initBlocks = blocks.querySelectorAll('[data-block="accordion"]');

  initBlocks.forEach((block) => {
    if (block.classList.contains("open")) {
      const content = block.querySelector('[data-content="toggle"]');

      if (content) {
        content.style.height = content.scrollHeight + "px";
      }
    }
  });
}
